export default __webpack_public_path__ + "static/media/slide5.dcdf5c7e.png";